"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useAnimate } from "framer-motion";
import { useClickAway, useKeyPressEvent } from "react-use";
import UserSettingsClassificationItem from "./UserSettingsClassificationItem";
import { ApiProfileClassification } from "@/generated/models/ApiProfileClassification";
import { CLASSIFICATIONS } from "@/entities/IProfile";
export default function UserSettingsClassification(t0) {
  const $ = _c(35);
  const {
    selected,
    onSelect
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleOpen = t1;
  let t2;
  if ($[2] !== animateIcon || $[3] !== iconScope || $[4] !== isOpen) {
    t2 = () => {
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    $[2] = animateIcon;
    $[3] = iconScope;
    $[4] = isOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t2);
  const listRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useClickAway(listRef, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useKeyPressEvent("Escape", t4);
  const [title, setTitle] = useState(CLASSIFICATIONS[selected].title);
  let t5;
  let t6;
  if ($[8] !== selected) {
    t5 = () => {
      setTitle(CLASSIFICATIONS[selected].title);
    };
    t6 = [selected];
    $[8] = selected;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== onSelect) {
    t7 = value => {
      onSelect(value);
      setIsOpen(false);
    };
    $[11] = onSelect;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const onClassification = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = Object.values(ApiProfileClassification);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const classifications = t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <label className="tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-300">Profile classification</label>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== title) {
    t10 = <span className="tw-text-iron-50">{title}</span>;
    $[15] = title;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== toggleOpen) {
    t11 = <button type="button" onClick={toggleOpen} className="tw-text-left tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-900 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-600 tw-text-base tw-transition tw-duration-300 tw-ease-out">{t10}</button>;
    $[17] = t10;
    $[18] = toggleOpen;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== iconScope) {
    t13 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3"><svg ref={iconScope} className="tw-h-5 tw-w-5 tw-text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t12}</svg></div>;
    $[21] = iconScope;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className="tw-mt-2 tw-relative">{t11}{t13}</div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isOpen || $[27] !== onClassification || $[28] !== selected) {
    t15 = isOpen && <motion.div className="tw-origin-top-right tw-z-10 tw-absolute tw-right-0 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-900 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-10 tw-mt-1 tw-overflow-hidden tw-max-w-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-max-h-[calc(280px+_-5vh)] tw-overflow-x-hidden tw-overflow-y-auto"><ul className="tw-flex tw-flex-col tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{classifications.map(classification => <UserSettingsClassificationItem key={classification} classification={classification} selected={selected} onClassification={onClassification} />)}</ul></div></div></motion.div>;
    $[26] = isOpen;
    $[27] = onClassification;
    $[28] = selected;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <AnimatePresence mode="wait" initial={false}>{t15}</AnimatePresence>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t14 || $[33] !== t16) {
    t17 = <div className="tw-max-w-full tw-relative" ref={listRef}>{t9}{t14}{t16}</div>;
    $[32] = t14;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
}